import { render, staticRenderFns } from "./_OptionGroup.vue?vue&type=template&id=2976ded2&scoped=true"
import script from "./_OptionGroup.vue?vue&type=script&lang=js"
export * from "./_OptionGroup.vue?vue&type=script&lang=js"
import style0 from "./_OptionGroup.vue?vue&type=style&index=0&id=2976ded2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2976ded2",
  null
  
)

export default component.exports